import { useEffect, useState } from "react";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";
import { PageContainer } from "components/shared";
import CheckImageBackConfirmManualPage from "components/pages/CheckImageBackConfirmManualPage/CheckImageBackConfirmManualPage";

export default function CaptureMabiDepositsBackAccept(props) {
    const [mabi23Branding, setMabi23Branding ] = useState({});

    const mabi23BrandingIsSet = Object.keys(mabi23Branding).length > 0;
    let mobileDepositsVersion = undefined;

    if(mabi23Branding.options) {
        mobileDepositsVersion = mabi23Branding.options.mobile_deposits_version_mabi23;
    }

    mobileDepositsVersion = mobileDepositsVersion === undefined || mobileDepositsVersion === "undefined" ? "Front & Back Images" : mobileDepositsVersion;
    mobileDepositsVersion = mobileDepositsVersion.toLowerCase();
    const hasAManualDepositVersion = mobileDepositsVersion === "manual front & back images" || mobileDepositsVersion === "manual check images";
    const brandingDisclaimer = `This capture is only shown when MABI23 branding option "Mobile Deposits Version" is set to either "Manual Front & Back Images" or "Manual Check Images".`;

    // useEffect will listen to the window event that triggers 
    // when mabi23 branding has been set in abi22.
    useEffect(() => {
        const handle = evt => {
            if(!mabi23BrandingIsSet) {
                setMabi23Branding(evt.detail);
            }
        }

        window.addEventListener("didSetMabi23Branding", handle);

        return () => {
            window.removeEventListener("didSetMabi23Branding", handle)
        };
    }, [mabi23Branding]);

    return (
        <>
            { !mabi23BrandingIsSet && <PageContainer className="hide"/> }
            { mabi23BrandingIsSet && hasAManualDepositVersion && <CheckImageBackConfirmManualPage className="capture-styles" /> }
            { mabi23BrandingIsSet && !hasAManualDepositVersion && <CaptureNotShownView message={ brandingDisclaimer }/> }
        </>
    );
}